import {Checkbox, Form, Radio} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {ExportColumnCatalogItemType} from '../../../../../../service/reviews/export-constructor/export-constructor-type';
import {classNames} from '../../../../../../util/css';
import {getColumnsForSheetType, getSheetLabel, getUniqueSheetTypes} from '../../reviews-export-constructor-helper';
import {ExportConstructorEditorFormEnum, ExportConstructorEditorFormType} from '../../reviews-export-constructor-types';

import * as styles from './export-template-column-picker.module.scss';

type PropsType = {
    catalog: Array<ExportColumnCatalogItemType>;
    sheetType?: string;
    disabled?: boolean;
};

export function ExportTemplateColumnPicker(props: PropsType): JSX.Element {
    const {catalog, sheetType, disabled} = props;

    const sheetTypes = sheetType ? [sheetType] : getUniqueSheetTypes(catalog);
    const showSheetLabel = !sheetType && sheetTypes.length > 1;

    return (
        <div className={styles.ExportTemplateColumnPicker}>
            {sheetTypes.map((currentSheetType) => {
                const sheetColumns = getColumnsForSheetType(catalog, currentSheetType);

                return (
                    <div className={styles.ExportTemplateColumnPicker_group} key={currentSheetType}>
                        {showSheetLabel ? (
                            <div className={styles.ExportTemplateColumnPicker_groupTitle}>
                                {getSheetLabel(catalog, currentSheetType)}
                            </div>
                        ) : null}
                        <Form.Item<ExportConstructorEditorFormType>
                            className={styles.ExportTemplateColumnPicker_checkboxGroup}
                            name={ExportConstructorEditorFormEnum.SelectedColumnIds}
                        >
                            <Checkbox.Group
                                className={styles.ExportTemplateColumnPicker_checkboxes}
                                disabled={disabled}
                            >
                                {sheetColumns.map((column) => (
                                    <Checkbox key={column.id} value={column.id}>
                                        {column.label}
                                    </Checkbox>
                                ))}
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                );
            })}
        </div>
    );
}

type OptionsPropsType = {
    className?: string;
    labelStringKey:
        | 'REVIEWS__EXPORT_CONSTRUCTOR__TAGS_FORMAT_LABEL'
        | 'REVIEWS__EXPORT_CONSTRUCTOR__AUTOTAGS_FORMAT_LABEL';
    name: ExportConstructorEditorFormEnum.TagsFormat | ExportConstructorEditorFormEnum.AutotagsFormat;
    disabled?: boolean;
};

// eslint-disable-next-line react/no-multi-comp
export function ExportTemplateColumnOptions(props: OptionsPropsType): JSX.Element {
    const {className, labelStringKey, name, disabled} = props;

    return (
        <Form.Item<ExportConstructorEditorFormType>
            className={classNames(styles.ExportTemplateColumnPicker_options, className)}
            label={<Locale stringKey={labelStringKey} />}
            name={name}
        >
            <Radio.Group disabled={disabled}>
                <Radio value="comma">
                    <Locale stringKey="REVIEWS__EXPORT_CONSTRUCTOR__FORMAT_COMMA" />
                </Radio>
                <Radio value="separate">
                    <Locale stringKey="REVIEWS__EXPORT_CONSTRUCTOR__FORMAT_SEPARATE" />
                </Radio>
            </Radio.Group>
        </Form.Item>
    );
}
